import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * AnalyticsTracker — fires a Google Analytics 4 `page_view` event on every
 * React Router location change (including the initial mount). Loaded from
 * inside <BrowserRouter> in App.js so it has access to useLocation().
 *
 * The gtag snippet in public/index.html is configured with
 *   gtag('config', 'G-VBTC6R5CXF', { send_page_view: false });
 * so THIS component is the single source of truth for page_view events.
 */
const GA_ID = "G-VBTC6R5CXF";

export const AnalyticsTracker = () => {
  const location = useLocation();
  const lastSent = useRef("");

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") {
      return;
    }
    const path = location.pathname + location.search;
    if (path === lastSent.current) return;
    lastSent.current = path;

    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
